import { filtersAtom, isEmptyFilterAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { Col, Row } from "@/utils/bootstrap";
import SortDropdown, {
  SortTypes,
} from "@/app/components/lib/sort-dropdown/SortDropdown";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import Filter from "@/app/components/common-filter-builder/filter/Filter";
import { clearAllFilters } from "@/app/components/common-filter-builder/flters-helpers/filter-functions";
import { usePathname } from "next/navigation";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";

const PCSort_Filter = () => {
  const [filtersIds, setFilterIds] = useAtom(filtersAtom);
  const pathname = usePathname();
  const router = useRouter();
  const [isEmptyFilter] = useAtom(isEmptyFilterAtom);
  const t = useTranslation();
  return (
    <>
      <div className="pc-sort-filter">
        <div className="title">{t.sort}</div>
        <SortDropdown isPC type={SortTypes.products} />
      </div>
      <div className="pc-sort-filter" style={{ marginTop: 24 }}>
        <Row className="m-0 d-flex justify-content-between align-items-center">
          <Col className="p-0 title">{t.filters}</Col>
          <Col className="p-0 col-auto">
            <CustomButton
              type={BtnTypes.primary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
              notAllowed={isEmptyFilter}
              onClick={() => {
                const { filterState } = clearAllFilters(filtersIds);
                setFilterIds(filterState);
                router.push(pathname);
              }}
            >
              {t.clear_filters}
            </CustomButton>
          </Col>
        </Row>
        <Filter PC />
      </div>
    </>
  );
};

export default PCSort_Filter;
